module.exports = __webpack_public_path__ + "a53a82e5f16b5ad4889f881bb0c5ee56.png";